// src/Pages/Usuario/Agenda/components/BotonDinamico.jsx
import React from "react";

export default function BotonDinamico({
  isOk,
  aceptaTerminos,
  planEntrada,
  reservarSesionIncluida,
  abrirPago,
}) {
  // Si faltan campos
  if (!isOk) {
    return (
      <button
        disabled
        className="w-full py-3 rounded-xl bg-gray-200 text-[#4B5563] cursor-not-allowed"
      >
        Completa todos los campos
      </button>
    );
  }

  // Si no acepta términos
  if (!aceptaTerminos) {
    return (
      <button
        disabled
        className="w-full py-3 rounded-xl bg-gray-200 text-[#4B5563] cursor-not-allowed"
      >
        Debes aceptar los Términos y Condiciones
      </button>
    );
  }

  // ================================
  // PLAN ACTIVO
  // ================================
  if (planEntrada) {
    // Sesión incluida
    if (planEntrada.pago_tipo === "incluida") {
      return (
        <button
          onClick={reservarSesionIncluida}
          className="w-full py-3 rounded-xl font-semibold shadow-lg bg-blue-600 text-white hover:bg-blue-700"
        >
          Reservar sesión incluida
        </button>
      );
    }

    // Pagar próxima sesión
    if (planEntrada.pago_tipo === "pago_proxima") {
      return (
        <button
          onClick={abrirPago}
          className="w-full py-3 rounded-xl font-semibold shadow-lg bg-amber-500 text-white hover:bg-amber-600"
        >
          Pagar próxima sesión
        </button>
      );
    }

    // Pagar saldo restante
    if (planEntrada.pago_tipo === "pago_total_restante") {
      return (
        <button
          onClick={abrirPago}
          className="w-full py-3 rounded-xl font-semibold shadow-lg bg-red-500 text-white hover:bg-red-600"
        >
          Pagar saldo restante del plan
        </button>
      );
    }
  }

  // ================================
  // SERVICIO NORMAL
  // ================================
  return (
    <button
      onClick={abrirPago}
      className="w-full py-3 rounded-xl font-semibold shadow-lg bg-[#00698F] text-white hover:brightness-110"
    >
      Pagar
    </button>
  );
}
